import { matchPath, useLocation } from 'react-router-dom';

export const useIsInSessionRoute = () => {
    const location = useLocation();
    return !!matchPath('/session/*', location.pathname);
};

// If we don't have access to the router, we can still check the current URL
// This is useful for cases where we need to check the route outside of a React component
// or when the router is not available (e.g., in a non-React context).
export const checkIsInSessionRouteWithoutRouter = (): boolean => {
    if (typeof window !== 'undefined') {
        const pathname = window.location.pathname;
        const sessionPathRegex = /^\/session\//;
        return sessionPathRegex.test(pathname);
    }
    return false;
};
